'use strict';

function ensureProductpoolResponseListeners() {
	if (window.__promProductpoolResponseListenersAttached) return;
	window.__promProductpoolResponseListenersAttached = true;

	window.__promLoadingPoolQueue = window.__promLoadingPoolQueue || [];

	function stopNextLoadingPool() {
		var queue = window.__promLoadingPoolQueue || [];
		if (!queue.length) return;
		// Do NOT dequeue here. We only want to signal that a response arrived; actual
		// skeleton removal should happen when the first product image is ready.
		var pool = queue[0];
		if (!pool || !pool.classList || !pool.classList.contains('is-loading')) return;
		pool.__promResponseReceived = true;
		if (typeof pool.__promTryStopLoading === 'function') {
			pool.__promTryStopLoading();
		}
	}

	// The int-vue-productpool library dispatches these events after responses.
	document.addEventListener('firstload', stopNextLoadingPool);
	document.addEventListener('loadpool', stopNextLoadingPool);
}

function enqueueLoadingPool(productpool) {
	if (!productpool) return;
	window.__promLoadingPoolQueue = window.__promLoadingPoolQueue || [];
	var queue = window.__promLoadingPoolQueue;
	if (queue.indexOf(productpool) === -1) queue.push(productpool);
}

function dequeueLoadingPool(productpool) {
	var queue = window.__promLoadingPoolQueue;
	if (!queue || !queue.length) return;
	var idx = queue.indexOf(productpool);
	if (idx >= 0) queue.splice(idx, 1);
}

function loadPoolWithoutScrolling(eventLike) {
	if (!window.INTPRODUCTPOOL || typeof window.INTPRODUCTPOOL.loadpool !== 'function') return;

	var scrollX = window.pageXOffset || 0;
	var scrollY = window.pageYOffset || 0;
	var originalScrollTo = window.scrollTo;
	var scrollToOverridden = false;

	// The external int-vue-productpool library calls `window.scrollTo(0, this.$el.offsetTop)`
	// inside its Vue component `loadpool()` method. For tab switching we do NOT want
	// any vertical page scrolling, so we temporarily noop scrollTo and also restore the
	// previous scroll position on the next tick as a safety net.
	try {
		window.scrollTo = function () {};
		scrollToOverridden = true;
	} catch (err) {
		// Some environments may disallow overwriting window.scrollTo.
	}

	try {
		window.INTPRODUCTPOOL.loadpool(eventLike);
	} finally {
		if (scrollToOverridden) {
			window.scrollTo = originalScrollTo;
		}

		if (typeof originalScrollTo === 'function') {
			setTimeout(function () {
				originalScrollTo.call(window, scrollX, scrollY);
			}, 0);
		}
	}
}

function updateSliderPositionForList(filterList) {
	if (!filterList) return;

	var activeTab = filterList.querySelector('.productpool-filter.active');
	if (!activeTab) return;

	var button = activeTab.querySelector('button');
	if (!button) return;

	// Calculate position and width of active button (scoped to this list)
	var rect = button.getBoundingClientRect();
	var listRect = filterList.getBoundingClientRect();
	var left = rect.left - listRect.left;
	var width = rect.width;

	// Update pseudo-element position on THIS list only
	filterList.style.setProperty('--slider-left', left + 'px');
	filterList.style.setProperty('--slider-width', width + 'px');
}

function updateAllSliderPositions() {
	var lists = document.querySelectorAll('.productpool-filters-list');
	if (!lists.length) return;
	for (var i = 0; i < lists.length; i++) {
		updateSliderPositionForList(lists[i]);
	}
}

function ensureSkeletonTrack(productpool, productgrid) {
	if (!productpool) return null;
	var track = productpool.querySelector('.prom-skeleton-track');
	if (track) return track;

	track = document.createElement('div');
	track.className = 'prom-skeleton-track';
	track.setAttribute('aria-hidden', 'true');

	var count = 6;
	for (var i = 0; i < count; i++) {
		var card = document.createElement('div');
		card.className = 'prom-skeleton-card';
		card.innerHTML =
			'<div class="prom-skeleton-card-inner">' +
			'<div class="prom-skeleton-image"></div>' +
			'<div class="prom-skeleton-line is-long"></div>' +
			'<div class="prom-skeleton-line is-short"></div>' +
			'</div>';
		track.appendChild(card);
	}

	// Insert before the productgrid so it sits where products would be.
	if (productgrid && productgrid.parentNode === productpool) {
		productpool.insertBefore(track, productgrid);
	} else {
		productpool.appendChild(track);
	}
	return track;
}

function setLoading(productpool, productgrid, isLoading) {
	if (!productpool) return;
	var MAX_MS = 60000;

	ensureProductpoolResponseListeners();

	if (isLoading) {
		enqueueLoadingPool(productpool);

		// Mark the start of a new loading cycle.
		productpool.__promSawReloadMutation = false;
		productpool.__promResponseReceived = false;
		productpool.__promLoadingStartedAt = Date.now();
		productpool.__promStopScheduled = false;
		productpool.__promFirstImageHooked = false;

		productpool.classList.add('is-loading');
		ensureSkeletonTrack(productpool, productgrid);

		// If user was scrolled, jump back so skeleton is visible.
		var productsEl = productgrid ? productgrid.querySelector('.productgrid-products') : null;
		if (productsEl) productsEl.scrollLeft = 0;

		function stopNow() {
			dequeueLoadingPool(productpool);
			productpool.classList.remove('is-loading');
			var t = productpool.querySelector('.prom-skeleton-track');
			if (t) t.remove();
			clearTimeout(productpool.__promLoadingTimeout);
			clearTimeout(productpool.__promMinLoadingTimeout);
			productpool.__promTryStopLoading = null;
		}

		function stopAfterPaint() {
			if (typeof window.requestAnimationFrame === 'function') {
				window.requestAnimationFrame(function () {
					window.requestAnimationFrame(function () {
						stopNow();
					});
				});
			} else {
				setTimeout(stopNow, 0);
			}
		}

		function canStopLoading() {
			var currentGrid = productpool.querySelector('.productgrid');
			var currentProductsEl = currentGrid ? currentGrid.querySelector('.productgrid-products') : null;
			if (!currentProductsEl) return false;

			var firstProduct = currentProductsEl.querySelector('.productgrid-product');
			if (!firstProduct) return false;

			// Wait until the first real product image is ready to paint.
			var img = firstProduct.querySelector('img');
			if (!img) return true;
			if (img.complete && img.naturalWidth > 0) return true;

			// Kick a one-time hook to re-check once the first image is ready.
			if (!productpool.__promFirstImageHooked) {
				productpool.__promFirstImageHooked = true;

				var onImgDone = function () {
					requestStopIfReady();
				};
				img.addEventListener('load', onImgDone, { once: true });
				img.addEventListener('error', onImgDone, { once: true });

				if (typeof img.decode === 'function') {
					img.decode().then(onImgDone).catch(onImgDone);
				}
			}

			return false;
		}

		function requestStopIfReady() {
			if (!productpool.classList.contains('is-loading')) return;
			if (!productpool.__promSawReloadMutation && !productpool.__promResponseReceived) return;
			if (!canStopLoading()) return;
			if (productpool.__promStopScheduled) return;
			productpool.__promStopScheduled = true;
			setTimeout(function () {
				// Re-check at time of stop.
				if (!productpool.classList.contains('is-loading')) return;
				if (canStopLoading()) stopAfterPaint();
				productpool.__promStopScheduled = false;
			}, 0);
		}

		// Expose for response-event-based triggers (firstload/loadpool).
		productpool.__promTryStopLoading = requestStopIfReady;

		// Observe the whole productpool so we still react if Vue replaces .productgrid.
		if (!productpool.__promLoadingObserver) {
			var mo = new MutationObserver(function () {
				productpool.__promSawReloadMutation = true;
				requestStopIfReady();
			});
			mo.observe(productpool, { childList: true, subtree: true });
			productpool.__promLoadingObserver = mo;
		}

		// Also listen for image load events to stop ASAP once an image completes.
		if (!productpool.__promImgLoadHandlerAttached) {
			productpool.addEventListener(
				'load',
				function (evt) {
					if (!productpool.classList.contains('is-loading')) return;
					var target = evt && evt.target;
					if (target && target.tagName === 'IMG') {
						requestStopIfReady();
					}
				},
				true
			);
			productpool.__promImgLoadHandlerAttached = true;
		}

		// Safety timeout so we never get stuck.
		clearTimeout(productpool.__promLoadingTimeout);
		productpool.__promLoadingTimeout = setTimeout(function () {
			stopNow();
		}, MAX_MS);
	} else {
		productpool.classList.remove('is-loading');
		var track = productpool.querySelector('.prom-skeleton-track');
		if (track) track.remove();
	}
}

function initInitialSkeletons() {
	var productpools = document.querySelectorAll('.productpool');
	if (!productpools.length) return;

	productpools.forEach(function (productpool) {
		var productgrid = productpool.querySelector('.productgrid');
		if (!productgrid) return;
		var productsEl = productgrid.querySelector('.productgrid-products');
		if (!productsEl) return;

		// If nothing has rendered yet, show skeleton until products arrive.
		if (!productsEl.querySelector('.productgrid-product')) {
			setLoading(productpool, productgrid, true);
		}
	});
}

function initTabFilters() {
	var productpools = document.querySelectorAll('.productpool');
	if (!productpools.length) {
		initInitialSkeletons();
		return;
	}

	productpools.forEach(function (productpoolRoot) {
		var filterList = productpoolRoot.querySelector('.productpool-filters-list');
		var filterTabs = productpoolRoot.querySelectorAll('.productpool-filter');
		if (!filterTabs.length) return;

		filterTabs.forEach(function (tab) {
			tab.addEventListener('click', function (e) {
			e.preventDefault();
			e.stopPropagation();
			if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

				var poolUrl = this.getAttribute('data-pool');
				var productpool = this.closest('.productpool');
				var productgrid = productpool
					? productpool.querySelector('.productgrid')
					: document.querySelector('.productgrid');

			if (!poolUrl || !productgrid) return;

				filterTabs.forEach(function (t) {
					t.classList.remove('active');
				});
			this.classList.add('active');

				// Update sliding background position (scoped to this list)
				updateSliderPositionForList(filterList);

			// Clear old items immediately so we never “complete” loading instantly.
			var productsEl = productgrid ? productgrid.querySelector('.productgrid-products') : null;
			if (productsEl) {
				// Capture current card/image dimensions so skeleton matches the real UI.
				var firstCard = productsEl.querySelector('.productgrid-product');
				var firstImageWrap = productsEl.querySelector('.productgrid-productimage-wrap');
				if (productpool) {
					if (firstCard) {
						var cardRect = firstCard.getBoundingClientRect();
						if (cardRect && cardRect.width) {
							productpool.style.setProperty('--prom-skeleton-card-w', Math.round(cardRect.width) + 'px');
						}
						if (cardRect && cardRect.height) {
							productpool.style.setProperty('--prom-skeleton-card-h', Math.round(cardRect.height) + 'px');
						}
					}
					if (firstImageWrap) {
						var imgRect = firstImageWrap.getBoundingClientRect();
						if (imgRect && imgRect.height) {
							productpool.style.setProperty('--prom-skeleton-image-h', Math.round(imgRect.height) + 'px');
						}
					}
				}

				productsEl.innerHTML = '';
				productsEl.scrollLeft = 0;
			}

			// Show skeleton loading state immediately to avoid layout jump.
			setLoading(productpool || productgrid, productgrid, true);

				productgrid.setAttribute('data-pool', poolUrl);

				// IMPORTANT: The int-vue-productpool library scrolls on loadpool().
				// Use a no-scroll wrapper so switching tabs doesn't jump the page.
				if (window.INTPRODUCTPOOL && typeof window.INTPRODUCTPOOL.loadpool === 'function') {
					loadPoolWithoutScrolling({
						currentTarget: this,
						preventDefault: function () {}
					});
				} else if (window.INTPRODUCTPOOL && typeof window.INTPRODUCTPOOL.start === 'function') {
					// Fallback: re-scan/re-init product grids.
					window.INTPRODUCTPOOL.start();
				}
			});
		});
	});

	// Initialize slider positions on load (all productpools)
	updateAllSliderPositions();

	// Show skeletons on initial load (before Vue products render).
	initInitialSkeletons();

	// Update sliders on window resize
	window.addEventListener('resize', updateAllSliderPositions);
}

module.exports = {
	initTabFilters: initTabFilters
};

